// UI
import FulfillmentSmallDisplay from './FulfillmentSmallDisplay'

export default function FulfillmentsDisplay({ fulfillments }) {
    return (
        <>
            {fulfillments.map((fulfillment) => (
                <FulfillmentSmallDisplay
                    key={fulfillment.id}
                    fulfillment={fulfillment}
                />
            ))}
        </>
    )
}
